import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// import Cookies from 'js-cookie';
import postAuthenticate from '../../api/private/users/posts/postAuthenticate';
// import { setLocalStorage } from '../../helper/LocalStorage';
// import postRevokeRefreshToken from '../../api/private/users/posts/postRevokeRefreshToken';
// import postRevokeToken from '../../api/private/users/posts/postRevokeToken';
// import { removeLocalStorage } from '../../helper/LocalStorage';
import jwtDecoder from '../../utils/jwtDecoder';

// create the thunk
export const fetchUser = createAsyncThunk(
  'users/fetchUser',
  async ({ email, password }) => {
    try {
      const res = await postAuthenticate(email, password);
      return { ...res.data, status: res.status };
    } catch (error) {
      console.error('Error: ', error);
      return error;
    }
  },
);

const initialState = {
  loginResponse: {},
  userProfile: {},
};

// Then, handle actions in your reducers:
const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    setUser: (state, action) => {
      state.userProfile = action.payload;
    },
    purgeUser: (state) => {
      // eslint-disable-next-line no-param-reassign, no-unused-vars
      state = initialState;
      return state;
    },
    setSelectedSite: (state, action) => {
      state.loginResponse.selectedSite = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.fulfilled, (state, action) => {
      if (action.payload.status === 200) {
        const jwtDecoded = jwtDecoder(action.payload.JwtToken);
        state.userProfile = jwtDecoded;
        // setLocalStorage('PrismProfile', jwtDecoded);
        state.loginResponse = action.payload;
      }
    });
  },
});

export const { setUser, purgeUser, setSelectedSite } = userSlice.actions;
export default userSlice.reducer;
